import React, { useState } from 'react';
import galleryData from '../../data/gallery.json';

const photos = galleryData.photos;

export default function GallerySection() {
    const [lightbox, setLightbox] = useState(null);

    return (
        <section id="gallery" className="bsides-gallery" style={{position:'relative',overflow:'hidden',}}>
            <style>{`
                .bsides-gallery {
                    background: var(--eventflow-black);
                    padding: 100px 0;
                    position: relative;
                    overflow: hidden;
                }
                .bsides-gallery::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background: radial-gradient(ellipse at 70% 30%, rgba(var(--eventflow-base-rgb),0.07) 0%, transparent 55%);
                    pointer-events: none;
                }

                /* masonry-style grid */
                .gallery-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    grid-auto-rows: 200px;
                    gap: 12px;
                    margin-bottom: 48px;
                }
                .gallery-item {
                    position: relative;
                    border-radius: 10px;
                    overflow: hidden;
                    cursor: pointer;
                    border: 1px solid rgba(var(--eventflow-white-rgb),0.06);
                }
                .gallery-item--wide { grid-column: span 2; }
                .gallery-item img {
                    width: 100%; height: 100%;
                    object-fit: cover;
                    display: block;
                    transition: transform 0.5s ease, filter 0.3s;
                    filter: brightness(0.8) saturate(0.9);
                }
                .gallery-item:hover img {
                    transform: scale(1.06);
                    filter: brightness(0.65) saturate(1.1);
                }
                .gallery-item__placeholder {
                    width: 100%; height: 100%;
                    background: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .gallery-item__placeholder span {
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    font-weight: 700;
                    color: #333;
                }
                .gallery-item__overlay {
                    position: absolute;
                    inset: 0;
                    background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 60%);
                    opacity: 0;
                    transition: opacity 0.3s;
                    display: flex;
                    align-items: flex-end;
                    padding: 16px;
                }
                .gallery-item:hover .gallery-item__overlay { opacity: 1; }
                .gallery-item__caption {
                    font-family: var(--eventflow-font);
                    font-size: 13px;
                    font-weight: 600;
                    color: var(--eventflow-white);
                }
                .gallery-item__zoom {
                    position: absolute;
                    top: 50%; left: 50%;
                    transform: translate(-50%, -50%) scale(0.7);
                    width: 44px; height: 44px;
                    border-radius: 50%;
                    background: rgba(var(--eventflow-base-rgb),0.9);
                    display: flex; align-items: center; justify-content: center;
                    opacity: 0;
                    transition: all 0.3s;
                }
                .gallery-item:hover .gallery-item__zoom {
                    opacity: 1;
                    transform: translate(-50%, -50%) scale(1);
                }
                .gallery-item__zoom i { font-size: 16px; color: #fff; }

                /* lightbox */
                .gallery-lightbox {
                    position: fixed;
                    inset: 0;
                    background: rgba(0,0,0,0.92);
                    z-index: 9999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    backdrop-filter: blur(8px);
                    animation: lbFadeIn 0.2s ease;
                }
                @keyframes lbFadeIn { from{opacity:0} to{opacity:1} }
                .gallery-lightbox__img {
                    max-width: 90vw;
                    max-height: 85vh;
                    border-radius: 12px;
                    box-shadow: 0 40px 100px rgba(0,0,0,0.8);
                    object-fit: contain;
                }
                .gallery-lightbox__close {
                    position: absolute;
                    top: 20px; right: 24px;
                    width: 44px; height: 44px;
                    border-radius: 50%;
                    background: rgba(255,255,255,0.1);
                    border: 1px solid rgba(255,255,255,0.15);
                    display: flex; align-items: center; justify-content: center;
                    cursor: pointer;
                    color: #fff;
                    font-size: 18px;
                    transition: background 0.2s;
                }
                .gallery-lightbox__close:hover { background: rgba(var(--eventflow-base-rgb),0.6); }
                .gallery-lightbox__caption {
                    position: absolute;
                    bottom: 24px;
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    color: rgba(255,255,255,0.6);
                }

                /* bottom cta */
                .gallery-cta {
                    text-align: center;
                }
                .gallery-cta p {
                    font-family: var(--eventflow-font);
                    font-size: 15px;
                    color: rgba(var(--eventflow-white-rgb),0.45);
                    margin-bottom: 20px;
                }

                @media (max-width: 991px) {
                    .gallery-grid { grid-template-columns: repeat(2,1fr); }
                    .gallery-item--wide { grid-column: span 2; }
                }
                @media (max-width: 576px) {
                    .gallery-grid { grid-template-columns: 1fr; grid-auto-rows: 180px; }
                    .gallery-item--wide { grid-column: span 1; }
                }
            `}</style>

            <div className="container">
                {/* Header */}
                <div className="text-center mb-5 wow fadeInUp" data-wow-delay="100ms">
                    <div className="bsides-section-tag" style={{justifyContent:'center'}}>{galleryData.section.eyebrow}</div>
                    <h2 className="bsides-section-title" style={{textAlign:'center'}}>{galleryData.section.title} <span>{galleryData.section.titleAccent}</span></h2>
                    <p style={{color:'rgba(255,255,255,0.5)',fontSize:'15px',maxWidth:'500px',margin:'0 auto'}}>
                        {galleryData.section.subtitle}
                    </p>
                </div>

                {/* Grid */}
                <div className="gallery-grid wow fadeInUp" data-wow-delay="150ms">
                    {photos.map((p, i) => (
                        <div
                            className={`gallery-item${p.span === 'wide' ? ' gallery-item--wide' : ''}`}
                            key={i}
                            onClick={() => p.src ? setLightbox(p) : null}
                        >
                            {p.src ? (
                                <img src={p.src} alt={p.caption} />
                            ) : (
                                <div className="gallery-item__placeholder">
                                    <span>Your Image</span>
                                </div>
                            )}
                            <div className="gallery-item__overlay">
                                <span className="gallery-item__caption">{p.caption}</span>
                            </div>
                            {p.src && <div className="gallery-item__zoom"><i className="fa fa-expand" /></div>}
                        </div>
                    ))}
                </div>

                {/* CTA Removed as requested */}
            </div>

            {/* Lightbox */}
            {lightbox && (
                <div className="gallery-lightbox" onClick={() => setLightbox(null)}>
                    <img className="gallery-lightbox__img" src={lightbox.src} alt={lightbox.caption} onClick={e => e.stopPropagation()} />
                    <div className="gallery-lightbox__close" onClick={() => setLightbox(null)}>
                        <i className="fa fa-times" />
                    </div>
                    <div className="gallery-lightbox__caption">{lightbox.caption}</div>
                </div>
            )}
        </section>
    );
}


